export default function PraiseMessage ({ score })  {
  let message = "";

  // Đưa ra lời khen dựa trên điểm số
  if (score >= 90) {
    message = "Xuất sắc! Bạn đã đạt điểm tuyệt đối!";
  } else if (score >= 75) {
    message = "Rất tốt! Bạn làm rất tốt!";
  } else if (score >= 50) {
    message = "Tốt! Hãy cố gắng hơn nữa nhé!";
  } else {
    message = "Đừng nản lòng! Hãy luyện tập thêm!";
  }

  return (

      <p className="text-lg mt-2">{message}</p>

  );
};

